import * as React from "react";

const IconErrorCircle = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <g fill="none" fill-rule="evenodd">
                <g fill="#AC1E2D" fill-rule="nonzero">
                    <path d="M8.515 7.772c.243.243.243.543.029.757-.215.228-.515.214-.758-.028-.6-.587-1.186-1.172-1.77-1.772-.587.586-1.188 1.185-1.773 1.772-.242.242-.542.242-.757.028-.228-.214-.214-.514.029-.757C4.1 7.172 4.686 6.586 5.286 6L3.515 4.23c-.243-.242-.243-.543-.029-.757.215-.229.515-.214.757.029.6.586 1.186 1.171 1.772 1.771.585-.586 1.186-1.185 1.77-1.771.244-.243.544-.243.759-.029.228.214.214.515-.03.757-.585.6-1.17 1.186-1.77 1.771.6.586 1.185 1.186 1.77 1.772M6 0C2.687 0 0 2.686 0 6s2.687 6 6 6c3.314 0 6-2.686 6-6S9.314 0 6 0"/>
                </g>
            </g>
        </svg>
    );
};

export default IconErrorCircle;